import React, {
    Fragment,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { AppContext } from "../context";
import { IMGFEEDBACK } from "../utils_new/Constants";
import {
    addImageToList,
    setLog,
    userLogs,
    patLogs,
    imageFeedbackLambda,
    translateText,
    setFeedbackCountResume,
    getTotalImageFeedbackMssgResume,
    setSubCompleted,
    getSubCompleted,
    setSubMandatoryCompleted,
    getSubMandatoryCompleted,
    getTotalImageFeedbackMssg,
    getImageFeedbackStatusNBtn,
    isAllImgUploaded,
    isImgExistFeedbackList,
    getKotakRecaptureCase,
    setKotakRecapMenuSection,
    setKotakRecapSubSection,
    getKotakRecapSubSection,
    getConstraint,
    getAspectRatioClientList,
    setImgFeedbackFlag,
    setGlobalImageQueue,
    getFeedbackTimer,
    setImgFeedbackCount,
    getImgFeedbackCount,
    setCameraOpenFlag,
    getCameraOpenFlag,
    getWebpImageFormat,
    imageRedirectFlags,
    getImgQualityFactor,
    getCountData,
    setRedisConfigData
} from "../context/utils";
import cameraImg from "../img/camera.png";
import Button from "./Button";
import Rotate from "./Rotate";
import leftArrow from "../img/left.png";
import rightArrow from "../img/right.png";
import car_inspection from "../img/car_inspection.png";
import white_tick from "../img/white_tick.png";
import instPopupGif from "../img/instPopupGif.gif";
import SafeImage from "./SafeImage";
import { startVideoPlayback } from "../utils_new/videoPlayback";
// import picture1 from "../img/Picture1.jpg";

// import ReactGA from "react-ga4";
let count = 0;
let logBugs = true;
let currentSubBlock = "";
let currentTag = "";
let imageCaptured = false;
let image = {};
let alignment = false;
let mandatoryMissing = [];
let subMissing = [];
// let cameraStarted = false;
let track = null;
let reservedData = null;
let tempStoredFeedBack = {};
let feedBackImages;
let videoConstraints;
let stencilUrl = "";
let videoEl;
let timerInterval;
let countDown = 25;
let feedBackBtndisabled = false;
let feedBackStatus = "";
let firstImgFlag = true;
let instPageFlag = true;

const New360ImgFeedback = () => {
    const {
        callOnceFeedBack,
        setCallOnceFeedBack,
        totalImageForAnalysis,
        setTotalImageForAnalysis,
        stepCovered,
        setStepCovered,
        clientId,
        showAlert,
        condition,
        setCondition,
        setScreen,
        currentBlock,
        showOptions,
        setShowOptions,
        config,
        isLandscape,
        setLandscape,
        mandatory,
        setMandatory,
        subMandatory,
        setSubMandatory,
        setCurrentPage,
        inspectionId,
        subCondition,
        setSubCondition,
        count1,
        setCount1,
        scrollX,
        setscrollX,
        scrolEnd,
        setscrolEnd,
        feedBackMssg,
        setFeedBackMssg,
        feedbackReceived,
        setFeedbackReceived,
        setImageFeedbackPopupRef,
        isIOS,
        subMandatorySub,
        subConditionSub,
        fallbackCondition,
        setFallbackCondition,
        fallbackSubCondition,
        setFallbackSubCondition,
        fallbackMandatory,
        setFallbackMandatory,
        fallbackSubMandatory,
        setFallbackSubMandatory,
        fallbackBlockId
    } = useContext(AppContext);

    const land = () => window.innerWidth > window.innerHeight * 1.2;
    const [instructions, setInstructions] = useState(null);
    const [currentBlockItem, setCurrentBlockItem] = useState(
        currentBlock["values"]
    );
    const [shadowUrl, setShadowUrl] = useState("");
    const [timeOutTimer, setTimeOutTimer] = useState(25000)

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    const [reduce, setReduce] = useState(false);
    if (logBugs) {
        patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
        userLogs({
            position: 8,
            last_page: `${currentBlock.tag} Module`,
            inspectionId,
        });
    }
    logBugs = false;
    const singleScreen = useRef();
    const videoRef = useRef();
    const canvasRef = useRef();
    const startBtn = useRef();
    const imgRef = useRef();
    const modalRef = useRef();
    const divImgRef = useRef();
    const feedbackPopCountText = useRef();
    const scrl = useRef();
    const feedBackPopUp = useRef();
    const redLineVINcontainer = useRef();
    const stencilBoxRef = useRef();
    const instPageRef = useRef();

    const setMandatoryCondition = async () => {
        let tempCondition = condition, tempMandatory = mandatory;
        // console.log("mandatory wala :::  ", tempCondition, tempMandatory, subMandatory)
        // console.log("fallbackBlockId: ", fallbackBlockId);

        tempCondition[fallbackBlockId] = "completed";
        setCondition(tempCondition);

        tempMandatory[fallbackBlockId] = "completed";
        setMandatory(tempMandatory);

        if (Object.keys(config).includes("resumeFlow") && config["resumeFlow"]) {
            setRedisConfigData(
                inspectionId,
                condition,
                mandatory,
                subMandatory,
                subCondition,
                subMandatorySub,
                subConditionSub,
            );
        }
    };


    const stencilResize = () => {
        requestAnimationFrame(() => {
            const containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight;

            const videoAspect = videoEl.videoWidth / videoEl.videoHeight;
            const containerAspect = containerWidth / containerHeight;

            let displayWidth, displayHeight;

            if (videoAspect > containerAspect) {
                // Video is wider — full width, black bars top/bottom
                displayWidth = containerWidth;
                displayHeight = containerWidth / videoAspect;
            } else {
                // Video is taller — full height, black bars sides
                displayHeight = containerHeight;
                displayWidth = containerHeight * videoAspect;
            }

            // Apply box size and position
            if (stencilBoxRef?.current && stencilUrl) {
                const box = stencilBoxRef.current;
                box.style.width = `${displayWidth}px`;
                box.style.height = `${displayHeight}px`;
                box.style.left = `${(containerWidth - displayWidth) / 2}px`;
                box.style.top = `${(containerHeight - displayHeight) / 2}px`;
                box.style.position = "absolute";
                box.style.display = "flex";
                box.style.pointerEvents = "none";
            }

            // Show buttons/overlays
        });
    };

    const startCamera = () => {
        try {
            navigator.mediaDevices
                .getUserMedia(getConstraint(config, clientId))
                .then((stream) => {
                    if (window.stream) {
                        window.stream.getTracks().forEach(track => track.stop());
                        window.stream = null;
                    }
                    window.stream = stream;
                    track = stream.getTracks()[0];
                    videoEl = videoRef.current;
                    if (videoEl) {
                        videoEl.srcObject = stream;
                        startVideoPlayback(videoEl, config);
                        videoEl.onloadedmetadata = () => {
                            if (reservedData) {
                                divImgRef.current.src = reservedData;
                                imgRef.current.style.display = "block";
                            }
                            // cameraStarted = true;
                            setCameraOpenFlag(true);
                            stencilResize();
                            setTimeout(() => {
                                if (startBtn.current) startBtn.current.style.display = "block";
                            }, 300);
                        };
                        if (
                            ["sompo_motorbike"].includes(clientId) &&
                            redLineVINcontainer.current
                        ) {
                            redLineVINcontainer.current.style.display = "flex";
                        }
                    }
                    else {
                        setTimeout(() => {
                            if (videoRef.current) {
                                videoRef.current.srcObject = stream;
                                startVideoPlayback(videoRef.current, config);
                                videoRef.current.onloadedmetadata = () => {
                                    if (reservedData) {
                                        divImgRef.current.src = reservedData;
                                        imgRef.current.style.display = "block";
                                    }
                                    // cameraStarted = true;
                                    setCameraOpenFlag(true);
                                    stencilResize();
                                    setTimeout(() => {
                                        if (startBtn.current) startBtn.current.style.display = "block";
                                    }, 300);
                                };
                                if (
                                    ["sompo_motorbike"].includes(clientId) &&
                                    redLineVINcontainer.current
                                ) {
                                    redLineVINcontainer.current.style.display = "flex";
                                }
                            }
                        }, 200);
                    }
                });
        } catch (err) {
            // console.log(err);
        }
    };

    const captureImg = async () => {
        // patLogs("capture image button clicked", inspectionId);
        const cnv = canvasRef.current;
        const vw = videoRef.current;
        cnv.width = vw.videoWidth;
        cnv.height = vw.videoHeight;
        cnv.getContext("2d").drawImage(vw, 0, 0);
        const imgData = getWebpImageFormat() && !isIOS
            ? cnv.toDataURL("image/webp", getImgQualityFactor())
            : cnv.toDataURL("image/jpeg");
        divImgRef.current.src = imgData;
        reservedData = imgData;
        let region = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu-central-1";
        image = {
            name: `${currentTag}.jpg`,
            imgData: imgData,
            tag: `${currentBlock.tag}: ${currentTag}`,
            web_region: null,
            angle: null,
            region: region,
            env: 1,
            videoData: null,
            dialStatus: null,
            currentTag,
            currentBlockName: currentBlock["id"],
            currentSubBlock,
            imageFeedbackFlag: false
        };
        if (redLineVINcontainer.current)
            redLineVINcontainer.current.style.display = "none";
        imgRef.current.style.display = "block";
    };

    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setscrollX(scrollX + shift);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const scrollCheck = () => {
        setscrollX(scrl.current.scrollLeft);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const imageRetake = () => {
        // patLogs("retake button clicked to capture image again", inspectionId);
        reservedData = null;
        if (redLineVINcontainer.current)
            redLineVINcontainer.current.style.display = "flex";
        imgRef.current.style.display = "none";
    };

    const goBack = () => {
        if (stencilBoxRef?.current) {
            stencilBoxRef.current.style.display = "none";
        }
        if (
            feedBackStatus === "Feedback" &&
            currentBlock["tag"] === "360 Image"
        ) {
            patLogs("back button clicked", inspectionId);
            modalRef.current.style.display = "flex";
            logBugs = true;
            return;
        }
        // cameraStarted = false;
        setCameraOpenFlag(false);
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        currentSubBlock = "";
        currentTag = "";
        alignment = false;
        setScreen("menu");
    };

    const removeModal = () => {
        // patLogs(
        //   `user clicked cross button to close warning and move to ${currentBlock.id}`,
        //   inspectionId
        // );
        if (modalRef && modalRef.current) modalRef.current.style.display = "none";
    };

    const modal = () => {
        if (getSubCompleted() && getSubMandatoryCompleted() && !feedBackBtndisabled) {
            imageAnalysis();
            return;
        }
        if (!getSubMandatoryCompleted() || !getSubCompleted() || feedBackBtndisabled) {
            patLogs(
                `clicked to submit button, Warning given to user some option is not completed`,
                inspectionId
            );
            if (modalRef && modalRef.current) modalRef.current.style.display = "flex";
            return;
        }
    };

    const setFeedbackReceivedHanlder = (currentTag) => {
        if (feedBackImages) {
            let temp = feedBackImages.filter((e) => e !== currentTag);
            feedBackImages = temp;
        }
    };

    const imageNext = () => {
        setGlobalImageQueue(image);
        if (stencilBoxRef?.current) {
            stencilBoxRef.current.style.display = "none";
        }
        logBugs = true;
        // patLogs(
        //   `tick button clicked image sent for uploading... and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        reservedData = null;
        if (imageCaptured) return;
        // cameraStarted = false;
        if (firstImgFlag && getCountData()) {
            imageRedirectFlags(inspectionId);
            firstImgFlag = false;
        }
        setCameraOpenFlag(false);
        imgRef.current.style.display = "none";
        imageCaptured = true;
        window.stream = null;
        track.stop();
        // let temp2 = subCondition;
        let temp2 = fallbackSubCondition;
        temp2[currentBlock.id][currentSubBlock] = "completed";
        // setSubCondition(temp2);
        setFallbackSubCondition(temp2);
        currentBlock.values.map((item) => {
            if (item.name === currentSubBlock && item.mandatory) {
                // let temp3 = subMandatory;
                let temp3 = fallbackSubMandatory;
                temp3[currentBlock.id][currentSubBlock] = "completed";
                setFallbackSubMandatory(temp3);
                //setSubMandatory(temp3);
            }
        });
        setKotakRecapSubSection(currentBlock["tag"], currentTag);
        setLog(`${currentTag} was captured`);
        //send image here----
        if (feedbackReceived.length === 0) {
            setTotalImageForAnalysis([...totalImageForAnalysis, image]);
            //setFeedbackCountResume(1 + getFeedbackCountResume());
            setImgFeedbackCount(1 + getImgFeedbackCount());
            checkImage(currentTag);
            count = count + 1;
        } else {
            if (feedBackImages && feedBackImages.length > 0) {
                setFeedbackReceivedHanlder(currentTag);
            }
            setFeedbackReceived(feedbackReceived.filter((e) => e !== currentTag));
            addImageToList(image);
            if (feedbackReceived.length === 1) {
                feedBackBtndisabled = false;
                feedBackStatus = "noFeedback";
            }
        }
        checkAll();
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock();
        }
        setCount1(count1 + 1);
        setShowOptions(true);
        if (feedbackReceived.length === 1) {
            modal();
        }
    };

    const checkImage = async (tag) => {
        let data = await imageFeedbackLambda({
            inspection_id: inspectionId,
            image: getWebpImageFormat() && !isIOS ? image["imgData"].replace(/^data:image\/webp;base64,/, "") : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
            tag: tag,
            type:
                currentBlock["type"] && currentBlock["type"] === "bike"
                    ? "bike"
                    : "car",
            client_id: clientId,
            imageDate: image,
            resumeFlag: false
        });
        if (data["feedback"].length > 0) {
        }
    };

    const sortBlock = () => {
        let tempCurrentBlock = currentBlockItem;
        if (
            feedBackImages &&
            feedBackImages.length > 0
        ) {
            tempCurrentBlock.sort((a, b) => {
                const aHasTag = feedBackImages.includes(a.tag);
                const bHasTag = feedBackImages.includes(b.tag);

                if (aHasTag && !bHasTag) return -1;
                if (!aHasTag && bHasTag) return 1;

                return 0;
            });
        } else {
            const subMissingSet = new Set(subMissing);
            const subMandatoryMissingSet = new Set(mandatoryMissing);

            tempCurrentBlock.sort((a, b) => {
                const aMandatoryIncomplete = subMandatoryMissingSet.has(a.name);
                const bMandatoryIncomplete = subMandatoryMissingSet.has(b.name);

                const aIncomplete = subMissingSet.has(a.name);
                const bIncomplete = subMissingSet.has(b.name);

                // Sort by mandatory and incomplete status
                if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
                if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

                if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

                if (aIncomplete && !bIncomplete) return -1;
                if (!aIncomplete && bIncomplete) return 1;

                return 0;
            });
        }
        setCurrentBlockItem(tempCurrentBlock);
    };

    const checkAll = () => {
        let tempSubCheck = true;
        let tempMandCheck = true;
        mandatoryMissing = [];
        subMissing = [];
        currentBlock.values.map(async (item) => {
            // if (subCondition[currentBlock.id][item.name] === "pending") {
            if (fallbackSubCondition[currentBlock.id][item.name] === "pending") {
                tempSubCheck = false;
                subMissing.push(item.name);
            }
            if (item.mandatory) {
                // if (subMandatory[currentBlock.id][item.name] === "pending") {
                if (fallbackSubMandatory[currentBlock.id][item.name] === "pending") {
                    tempMandCheck = false;
                    if (!totalImageForAnalysis.map((e) => e["currentTag"]).includes(item.tag)) {
                        mandatoryMissing.push(item.name);
                    }
                }
            }
        });

        if (tempSubCheck) {
            setSubCompleted(true);
        }
        if (tempMandCheck) {
            setSubMandatoryCompleted(true);
        }
    };

    const back = () => {
        // patLogs(
        //   `back button is clicked and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        currentSubBlock = "";
        currentTag = "";
        imageCaptured = true;
        // cameraStarted = false;
        setCameraOpenFlag(false);
        window.stream = null;
        track.stop();
        setShowOptions(true);
    };

    const useEffectFeedback = async () => {
        count = 0;
        currentSubBlock = "";
        currentTag = "";
        image = {};
        mandatoryMissing = [];
        subMissing = [];
        track = null;
        reservedData = null;
        stencilUrl = "";
        setCount1(count1 + 1);
        imageCaptured = true;
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock();
        }
    }

    const imageAnalysis = () => {
        if (callOnceFeedBack) {
            setCallOnceFeedBack(false);
            removeModal();
            feedBackStatus = "checking";
            if (feedBackPopUp && feedBackPopUp.current) {
                feedBackPopUp.current.style.display = "flex";
                feedbackPopCountText.current.innerHTML = getTranslateText(`Hang tight! We’re analyzing your images — this will only take a ${countDown} seconds.`);
            }
            setTimeout(async () => {
                try {
                    let imageFeedbackMsg = getTotalImageFeedbackMssgResume();
                    let tempmsgFeedback = {};
                    if (Object.keys(imageFeedbackMsg).length > 0) {
                        for (let e in imageFeedbackMsg) {
                            if (imageFeedbackMsg[e].length > 0) {
                                tempmsgFeedback[e] = imageFeedbackMsg[e];
                            }
                        }
                        if (Object.keys(tempmsgFeedback).length > 0) {
                            setFeedbackReceived(Object.keys(tempmsgFeedback));
                            feedBackImages = Object.keys(tempmsgFeedback);
                        }
                        feedBackBtndisabled = true;
                        feedBackStatus = "Feedback";
                        setFeedbackCountResume(0);
                    }
                    totalImageForAnalysis.map((e) => {
                        if (!Object.keys(imageFeedbackMsg).includes(e.currentTag)) {
                            addImageToList(e);
                        } else {
                            if (imageFeedbackMsg[e.currentTag].length === 0) {
                                addImageToList(e);
                            } else {
                                feedBackStatus = "Feedback";
                            }
                        }
                    });
                    if (
                        Object.keys(getTotalImageFeedbackMssg()).length === 0 ||
                        Object.keys(tempmsgFeedback).length === 0
                    ) {
                        feedBackStatus = "noFeedback";
                        clearInterval(timerInterval);
                        userLogs({
                            position: 17,
                            feedback_countDown: feedBackStatus + " " + 1,
                            inspectionId,
                        });
                        finsh(true);
                        return;
                    }
                    clearInterval(timerInterval);
                    userLogs({
                        position: 17,
                        feedback_countDown: feedBackStatus + " " + 1,
                        inspectionId,
                    });
                    await useEffectFeedback()
                    feedBackPopUp.current.style.display = "none";
                }
                catch (err) {
                    feedBackPopUp.current.style.display = "none";
                }
            }, timeOutTimer);
            timerInterval = setInterval(() => {
                if (countDown > 0) {
                    let tempcount = countDown - 1;
                    feedbackPopCountText.current.innerHTML = getTranslateText("Hang tight! We’re analyzing your images — this will only take a # seconds.").replace("#", tempcount);
                    countDown = tempcount;
                } else {
                    clearInterval(timerInterval);
                }
            }, 1000);
        } else {
            finsh(true);
            alignment = false;
        }
    };

    const finsh = async (value) => {
        if (!getSubMandatoryCompleted) return;
        patLogs(`${currentBlock.id} is completed`, inspectionId);
        // cameraStarted = false;
        setCameraOpenFlag(false);
        // let temp = condition;
        let temp = fallbackCondition;
        if (currentBlock.mandatory) {
            // let temp1 = mandatory;
            let temp1 = fallbackMandatory;
            temp1[currentBlock.id] = "completed";
            // setMandatory(temp1);
            setFallbackMandatory(temp1);
        }
        image = {};
        currentSubBlock = "";
        currentTag = "";
        imageCaptured = false;
        temp[currentBlock.id] = "completed";
        setLog(`${currentBlock["tag"]} was finished`);
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        // setCondition(temp);
        setFallbackCondition(temp);
        setKotakRecapMenuSection(currentBlock["tag"]);
        if (feedBackPopUp && feedBackPopUp.current) feedBackPopUp.current.style.display = "none";
        if (value) {
            setMandatoryCondition();
            imageRedirectFlags(inspectionId);
            Object.keys(config).includes("directModule") && config["directModule"] ? setScreen("success") : setScreen("menu");
        }
    };

    useEffect(() => {
        if (stencilBoxRef.current) {
            stencilBoxRef.current.style.display = "none";
        }
        instPageRef.current.style.display = "flex";
        setLandscape(land());
        checkAll();
        setCount1(count1 + 1);
        if (currentBlock["values"].length <= 3) {
            alignment = true;
        }
        imageCaptured = true;
        currentBlock["values"].map((e) => {
            if (e["name"].length > 14) {
                setReduce(true);
            }
        });
        if (feedbackReceived.length > 0) {
            feedBackImages = feedbackReceived;
        }
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock();
        }
        if (feedBackStatus === "Feedback") {
            setSubMandatoryCompleted(true);
            setSubCompleted(true);
        } else if (["", "checking"].includes(getImageFeedbackStatusNBtn()[0]) && (getImgFeedbackCount() >= 8 || Object.keys(getTotalImageFeedbackMssgResume()).length >= 8)
        ) {
            setSubCompleted(true);
            setSubMandatoryCompleted(true);
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setLandscape(land());
            if (!land()) setCameraOpenFlag(false);
            else if (land()) {
                if (!getCameraOpenFlag()) setTimeout(() => startCamera(), 100);
                if (instPageFlag) instPageRef.current.style.display = "flex";
            }
            // if (land() && getCameraOpenFlag()) setTimeout(() => startCamera(), 100);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            if (window.stream) {
                window.stream.getTracks().forEach(track => track.stop());
                window.stream = null;
            }
        }
    }, []);

    const showFeedBackMssg = (value) => {
        setFeedBackMssg(value);
    };

    const captureFeedBackImage = (item) => {
        setFeedBackMssg("");
        patLogs(`${item["tag"]} is clicked`, inspectionId);
        currentSubBlock = item["name"];
        currentTag = item["tag"];
        setShowOptions(false);
        imageCaptured = false;
        startCamera();
        Object.keys(item).includes("cameraInstruction") &&
            setInstructions(item["cameraInstruction"]);
    };

    const langConverstion = (value) => {
        if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes(value)) {
            return getTranslateText(IMGFEEDBACK["ReasonMssg"][value]);
        }
        else if (value.includes("You did not capture these parts in the image:")) {
            if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes("You did not capture these parts in the image:")) {
                let parts = value.split(":")[1].split(",");
                let partCoversion = "";
                parts.map((e) => {
                    if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes(e.trim())) {
                        partCoversion = `${partCoversion}, ${IMGFEEDBACK["ReasonMssg"][e.trim()]}`;
                    }
                    else {
                        partCoversion = e.trim();
                    }
                });
                return `${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You did not capture these parts in the image:"]).trim()} ${partCoversion}`;
            }
            else {
                return getTranslateText(value);
            }
        }
        else if (value.includes("You captured the wrong side. Please capture")) {
            if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes("You captured the wrong side. Please capture # again.") && !IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. Please capture # again."].includes("#")) {
                return getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. Please capture # again."]);
            }
            else if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes("You captured the wrong side. Please capture # again.")) {
                let detectRegion = IMGFEEDBACK["ReasonMssg"][value.split("#")[1].trim()] || value.split("#")[1].trim();
                return `${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. Please capture # again."]).split("#")[0].trim()} ${detectRegion} ${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. Please capture # again."]).split("#")[1].trim()}`;
            }
            else {
                return getTranslateText(value);
            }
        }
        else if (value.includes("You captured the wrong side. You captured ")) {
            if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes("You captured the wrong side. You captured # in stead of # .") && !IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."].includes("#")) {
                return getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."]);
            }
            else if (Object.keys(IMGFEEDBACK["ReasonMssg"]).includes("You captured the wrong side. You captured # in stead of # .")) {
                let detectRegion1 =
                    IMGFEEDBACK["ReasonMssg"][value.split("#")[1].trim()] || value.split("#")[1].trim();
                let detectRegion2 = IMGFEEDBACK["ReasonMssg"][value.split("#")[3].trim()] || value.split("#")[3].trim();
                return `${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."]).split("#")[0].trim()} ${detectRegion1} ${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."]).split("#")[1].trim()} ${detectRegion2} ${getTranslateText(IMGFEEDBACK["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."]).split("#")[2].trim()}`;
            } else {
                return getTranslateText(value);
            }
        } else {
            return getTranslateText(value);
        }
    };


    return (
        <Fragment>
            {!isLandscape ? (
                <Rotate />
            ) : showOptions ? (
                <div className="process" style={{ position: "relative" }}>
                    <h2>{getTranslateText(currentBlock["id"])}</h2>
                    <div ref={feedBackPopUp} className="imageFeedBackPopup">
                        <div style={{ zIndex: 5 }}>
                            <p ref={getTranslateText(feedbackPopCountText)} style={{ margin: "2px" }}></p>
                            <img
                                style={{ width: "80px", height: "80px" }}
                                src={car_inspection}
                            />
                        </div>
                    </div>
                    <div ref={instPageRef} id="display-card-dashboard">
                        <div id="instPopHeaderText">
                            <h2 style={{ margin: "0px", padding: "10px 0px 0px 0px" }}>{getTranslateText("How to capture your vehicle")}</h2>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", "justifyContent": "space-between", width: "100%", paddingTop: "2%" }}>
                            <div id="image-container" style={{ width: "unset", paddingLeft: "2%" }}>
                                <img style={{ width: "45dvw", borderRadius: "5%", height: "50dvh" }} src={instPopupGif}></img>
                            </div>
                            <div className="space-y-4" style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                height: "100%",
                                padding: "5px 5px 1px 30px"
                            }}>
                                {/* Step 1 */}
                                <div className="step-item">
                                    <div className="step-content">
                                        <h4 style={{ margin: "0px" }}>{getTranslateText("Capture 8 Sides")}</h4>
                                        <p>{getTranslateText("Tap a section in the grid to open the camera. Align your car and capture it.")}</p>
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div className="step-item">
                                    <div className="step-content">
                                        <h4 style={{ margin: "0px" }}>{getTranslateText("Submit & Analyze")}</h4>
                                        <p>{getTranslateText("Once all section turn green, hit Submit button. Our AI checks quality in ~25 seconds.")}</p>
                                    </div>
                                </div>

                                {/* Step 3 */}
                                <div className="step-item">
                                    <div className="step-content">
                                        <h4 style={{ margin: "0px" }}>{getTranslateText("Fix Red Sections")}</h4>
                                        <p style={{ display: "inline" }}>{getTranslateText("If a section turns RED, tap it to see the feedback and retake it.")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="btn-container" style={{ paddingBottom: "unset", paddingRight: "10%", height: "15%" }}>
                            <button
                                style={{
                                    backgroundColor: config["colors"]["btn"],
                                    color: "var(--btn-text, #fff)",
                                    width: "25%",
                                    height: "100%",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontSize: "18px",
                                    fontWeight: 500,
                                }}
                                onClick={() => {
                                    instPageFlag = false;
                                    instPageRef.current.style.display = "none";
                                }}
                            >
                                {getTranslateText("Start Inspection")}
                            </button>
                        </div>
                    </div>
                    {feedBackMssg.length > 0 && (
                        <div style={{ display: "flex" }} className="imageFeedBackPopup">
                            <div
                                style={{
                                    justifyContent: "space-around",
                                    textAlign: "left",
                                    height: "45vh",
                                    width: "55vw",
                                    zIndex: 5,
                                }}
                            >
                                <h2 style={{ margin: "0px" }}>
                                    {getTranslateText("Reason")}
                                </h2>
                                <ul>
                                    {feedBackMssg.map((e) => {
                                        return (
                                            <li style={{ padding: "2px 0px" }}>
                                                {langConverstion(e)}
                                            </li>
                                        );
                                    })}
                                </ul>
                                <button
                                    className="feedbackbtn"
                                    style={{
                                        backgroundColor: config["colors"]["btn"],
                                        fontSize: "18px",
                                    }}
                                    onClick={() => {
                                        captureFeedBackImage(tempStoredFeedBack);
                                    }}
                                >
                                    {getTranslateText("Recapture image")}
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="process-main" style={{ display: "flex" }}>
                        <div
                            className="left-btn"
                            disabled={scrollX === 0}
                            onClick={() => slide(-200)}
                            style={alignment ? { display: "none" } : {}}
                        >
                            <img
                                src={leftArrow}
                                style={scrollX === 0 ? { opacity: "0.3" } : {}}
                            />
                        </div>
                        <div
                            className="process-steps"
                            ref={scrl}
                            onScroll={scrollCheck}
                            style={
                                alignment
                                    ? {
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100vw",
                                    }
                                    : {
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        width: "80vw",
                                        overflowX: "scroll",
                                        scrollBehavior: "smooth",
                                        alignItems: "center",
                                    }
                            }
                        >
                            {currentBlockItem.map((item, index) => {
                                if (
                                    Object.keys(getTotalImageFeedbackMssg()).length > 0 &&
                                    Object.keys(getTotalImageFeedbackMssg()).includes(item.tag) &&
                                    currentBlock["link"] ===
                                    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_360+view.svg"
                                ) {
                                    return (
                                        <div key={index}>
                                            <div
                                                className="menu-options"
                                                style={reduce ? { fontSize: "10px" } : null}
                                            >
                                                <h4
                                                    style={
                                                        feedbackReceived.includes(item.tag)
                                                            ? {
                                                                color: "red",
                                                            }
                                                            : {
                                                                color: `${config["colors"]["complete-block"]}`,
                                                            }
                                                    }
                                                    key={index}
                                                >
                                                    {getTranslateText(item["name"])}
                                                </h4>
                                                <div
                                                    className="process-vin"
                                                    style={
                                                        feedbackReceived.includes(item.tag)
                                                            ? {
                                                                border: "2px solid red",
                                                            }
                                                            : {
                                                                border: `2px solid ${config["colors"]["complete-block"]}`,
                                                                opacity:
                                                                    feedBackPopUp.current &&
                                                                        feedBackPopUp.current.style.display ===
                                                                        "flex"
                                                                        ? ".5"
                                                                        : "",
                                                            }
                                                    }
                                                    onClick={() => {
                                                        if (feedbackReceived.includes(item.tag)) {
                                                            tempStoredFeedBack = item;
                                                            let feedbackMsg = getTotalImageFeedbackMssg();
                                                            stencilUrl = Object.keys(item).includes("stencils")
                                                                ? item["stencils"]
                                                                : "";

                                                            setShadowUrl(
                                                                Object.keys(item).includes("shadowBox")
                                                                    ? item["shadowBox"]
                                                                    : ""
                                                            );
                                                            showFeedBackMssg(feedbackMsg[item.tag]);
                                                        }
                                                    }}
                                                >
                                                    {!feedbackReceived.includes(item.tag) && (
                                                        <div
                                                            className="greenCircleTick"
                                                            style={
                                                                feedBackPopUp.current &&
                                                                    feedBackPopUp.current.style.display === "flex"
                                                                    ? { opacity: ".5" }
                                                                    : {}
                                                            }
                                                        >
                                                            <img src={white_tick} alt="1232"></img>
                                                        </div>
                                                    )}
                                                    <SafeImage style={["Left Capture", "Right Capture"].includes(item["tag"]) && ["client_1525", "client_1671"].includes(clientId) ? { "objectFit": "fill" } : {}} src={item["image"]} alt="123" />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                } else if (
                                    // subCondition[currentBlock.id][item.name] === "completed"
                                    fallbackSubCondition[currentBlock.id][item.name] === "completed"
                                ) {
                                    return (
                                        <div key={index}>
                                            <div
                                                className="menu-options"
                                                style={reduce ? { fontSize: "10px" } : null}
                                            >
                                                {item["mandatory"] ? (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {getTranslateText(item["name"])}&#42;
                                                    </h4>
                                                ) : (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {getTranslateText(item["name"])}
                                                    </h4>
                                                )}
                                                <div
                                                    className="process-vin"
                                                    style={{
                                                        border:
                                                            getKotakRecaptureCase() &&
                                                                getKotakRecapSubSection(
                                                                    currentBlock["tag"],
                                                                    item["tag"]
                                                                )
                                                                ? "2px solid rgb(0, 180, 160)"
                                                                : `2px solid ${config["colors"]["complete-block"]}`,
                                                        opacity:
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? ".5"
                                                                : "",
                                                    }}
                                                    onClick={() => {
                                                        if (
                                                            Object.keys(config).includes(
                                                                "recaptureAfterSubmit"
                                                            ) &&
                                                            config["recaptureAfterSubmit"] &&
                                                            getKotakRecaptureCase() &&
                                                            !getKotakRecapSubSection(
                                                                currentBlock["tag"],
                                                                item["tag"]
                                                            )
                                                        ) {
                                                            //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                            currentSubBlock = item["name"];
                                                            currentTag = item["tag"];
                                                            stencilUrl = Object.keys(item).includes(
                                                                "stencils"
                                                            )
                                                                ? item["stencils"]
                                                                : "";

                                                            setShadowUrl(
                                                                Object.keys(item).includes("shadowBox")
                                                                    ? item["shadowBox"]
                                                                    : ""
                                                            );
                                                            setShowOptions(false);
                                                            imageCaptured = false;
                                                            startCamera();
                                                            Object.keys(item).includes("cameraInstruction") &&
                                                                setInstructions(item["cameraInstruction"]);
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className="greenCircleTick"
                                                        style={
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? { opacity: ".5" }
                                                                : {
                                                                    backgroundColor:
                                                                        getKotakRecaptureCase() &&
                                                                            getKotakRecapSubSection(
                                                                                currentBlock["tag"],
                                                                                item["tag"]
                                                                            )
                                                                            ? "rgb(0, 180, 160)"
                                                                            : "",
                                                                }
                                                        }
                                                    >
                                                        <img src={white_tick} alt="1232"></img>
                                                    </div>
                                                    <SafeImage style={["Left Capture", "Right Capture"].includes(item["tag"]) && ["client_1525", "client_1671"].includes(clientId) ? { "objectFit": "fill" } : {}} src={item["image"]} alt="123" />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }
                                return (
                                    <div key={index}>
                                        <div
                                            className="menu-options"
                                            style={reduce ? { fontSize: "10px" } : null}
                                        >
                                            {item["mandatory"] ? (
                                                <h4 key={index}>{getTranslateText(item["name"])}&#42;</h4>
                                            ) : (
                                                <h4 key={index}>{getTranslateText(item["name"])}</h4>
                                            )}
                                            <div
                                                className="process-vin"
                                                style={{
                                                    border: `1px solid ${config["colors"]["incomplete-block"]}`,
                                                }}
                                                onClick={() => {
                                                    //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                    currentSubBlock = item["name"];
                                                    currentTag = item["tag"];
                                                    stencilUrl = Object.keys(item).includes("stencils")
                                                        ? item["stencils"]
                                                        : "";

                                                    setShadowUrl(
                                                        Object.keys(item).includes("shadowBox")
                                                            ? item["shadowBox"]
                                                            : ""
                                                    );
                                                    setShowOptions(false);
                                                    imageCaptured = false;
                                                    startCamera();
                                                    Object.keys(item).includes("cameraInstruction") &&
                                                        setInstructions(item["cameraInstruction"]);
                                                }}
                                            >
                                                <SafeImage style={["Left Capture", "Right Capture"].includes(item["tag"]) && ["client_1525", "client_1671"].includes(clientId) ? { "objectFit": "fill" } : {}} src={item["image"]} alt="123" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            className="right-btn"
                            disabled={scrolEnd}
                            style={alignment ? { display: "none" } : {}}
                            onClick={() => slide(+200)}
                        >
                            <img
                                src={rightArrow}
                                style={scrolEnd ? { opacity: "0.3" } : {}}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex" }} className="InternetWarning">
                        <p>{showAlert && showAlert}</p>
                    </div>
                    <div
                        className="modal-btn-container-multipleImage"
                        style={{ display: "flex", backgroundColor: "#F8F7FC" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                width: "100%",
                            }}
                        >
                            <Button
                                text={config["multiple-image-page"]["next-btn-text"]}
                                disabled={
                                    feedBackBtndisabled || !getSubMandatoryCompleted()
                                }
                                onclick={() => { modal() }}
                                marginDefault="0px 25px 0px 25px"
                            />
                        </div>
                    </div>
                    <div
                        ref={modalRef}
                        className="menu-modal-container"
                        style={{ display: "none" }}
                    >
                        {!getSubMandatoryCompleted() ? (
                            <div
                                className="skipDiv"
                                style={{
                                    display: "flex",
                                    width: "90dvw",
                                    maxWidth: "450px", // Limits width on larger screens
                                    height: "auto",
                                    minHeight: "200px",
                                    zIndex: 10,
                                    backgroundColor: "#ffffff",
                                    borderRadius: "20px",
                                    padding: "30px 24px",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    fontFamily: "system-ui, -apple-system, sans-serif",
                                }}
                            >
                                <h3
                                    style={{
                                        fontSize: "1.1rem",
                                        color: "#2c3e50",
                                        lineHeight: "1.6",
                                        margin: "0 0 1px 0",
                                        fontWeight: "500",
                                    }}
                                >
                                    {getTranslateText("Please complete all sections before submitting")}
                                </h3>

                                <div style={{ padding: "15px" }} id="missingSections">
                                    {mandatoryMissing.map((e) => (
                                        <li style={{ margin: 0 }}>{e.trim()}</li>
                                    ))}
                                </div>

                                <div
                                    className="skipDivButtons"
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        width: "100%",
                                        marginTop: "auto",
                                    }}
                                >
                                    {/* Continue Button - Secondary Action */}
                                    <div
                                        onClick={async () => {
                                            modalRef.current.style.display = "none";
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: "14px 0",
                                            borderRadius: "12px",
                                            backgroundColor: config["colors"]["btn"],
                                            color: "var(--btn-text, #fff)",
                                            fontSize: "1rem",
                                            fontWeight: "600",
                                            textAlign: "center",
                                            transition: "background 0.2s ease",
                                        }}
                                    >
                                        {config["video-page"]["Continue"] || getTranslateText("Continue")}
                                    </div>
                                </div>
                            </div>
                        ) : feedBackBtndisabled ? (
                            <div
                                className="skipDiv"
                                style={{
                                    display: "flex",
                                    width: "90dvw",
                                    maxWidth: "450px", // Limits width on larger screens
                                    height: "auto",
                                    minHeight: "200px",
                                    zIndex: 10,
                                    backgroundColor: "#ffffff",
                                    borderRadius: "20px",
                                    padding: "30px 24px",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    textAlign: "center",
                                    fontFamily: "system-ui, -apple-system, sans-serif",
                                }}
                            >
                                <h3
                                    style={{
                                        fontSize: "1.1rem",
                                        color: "#2c3e50",
                                        lineHeight: "1.6",
                                        margin: "0 0 24px 0",
                                        fontWeight: "500",
                                    }}
                                >
                                    {getTranslateText("Please complete all sections before submitting")}
                                </h3>

                                <div
                                    className="skipDivButtons"
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        width: "100%",
                                        marginTop: "auto",
                                    }}
                                >
                                    {/* Continue Button - Secondary Action */}
                                    <div
                                        onClick={async () => {
                                            modalRef.current.style.display = "none";
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: "14px 0",
                                            borderRadius: "12px",
                                            backgroundColor: config["colors"]["btn"],
                                            color: "var(--btn-text, #fff)",
                                            fontSize: "1rem",
                                            fontWeight: "600",
                                            textAlign: "center",
                                            transition: "background 0.2s ease",
                                        }}
                                    >
                                        {config["video-page"]["Continue"] || getTranslateText("Continue")}
                                    </div>
                                </div>
                            </div>) : null}
                    </div>
                    {/* <div
                        ref={modalRef}
                        className="menu-modal-container"
                        style={{ display: "none" }}
                    >
                        {!getSubMandatoryCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["mandatory-modal-text"]}</h4>
                                <h4>{mandatoryMissing.join(", ")}</h4>
                            </div>)
                            : feedBackBtndisabled ? (
                                <div className="menu-modal">
                                    <div className="menu-back-btn">
                                        <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                    </div>
                                    <h4>{getTranslateText("Please complete all sections before submitting.")}</h4>
                                </div>
                            ) : null}
                    </div> */}
                </div>
            ) : (
                <div id="vin-screen" ref={singleScreen}>
                    <canvas
                        ref={canvasRef}
                        id="ios-canvas"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? {
                                    width: "100vw",
                                    height: "100vh",
                                    objectFit: "contain",
                                    backgroundColor: "black",
                                }
                                : {}
                        }
                    ></canvas>
                    <div
                        id="newimgAppDiv"
                        style={{ width: "100dvw", height: "100dvh", position: "absolute" }}
                    >
                        <video
                            ref={videoRef}
                            id="videoWindow"
                            style={
                                getAspectRatioClientList(clientId, config)
                                    ? {
                                        width: "100vw",
                                        height: "100vh",
                                        objectFit: "contain",
                                        backgroundColor: "black",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                    }
                                    : { position: "absolute", top: 0, left: 0 }
                            }
                            autoPlay
                            playsInline
                        ></video>
                        <div
                            className="stencilBox"
                            ref={stencilBoxRef}
                            style={{
                                position: "absolute",
                                // border: "1px solid red",
                            }}
                        >
                            <SafeImage
                                src={stencilUrl}
                                alt=""
                                fallback={null}
                                style={
                                    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                                        !window.MSStream
                                        ? {
                                            width: "90%",
                                            height: "90%",
                                            objectFit: "contain",
                                        }
                                        : { width: "100%", height: "100%", objectFit: "contain" }
                                }
                            />
                        </div>
                    </div>
                    {["sompo_motorbike"].includes(clientId) && (
                        <div
                            className="redLineVINcontainerView"
                            style={{
                                paddingTop: "5%",
                                justifyContent: "flex-start",
                                width: "unset",
                            }}
                            ref={redLineVINcontainer}
                        >
                            <div id="modalNameCont">
                                <p id="modalNameText">{currentSubBlock}</p>
                            </div>
                        </div>
                    )}
                    {shadowUrl && (
            <SafeImage src={shadowUrl} alt="" className="car-stencil" fallback={null} />
          )}
                    <div
                        ref={startBtn}
                        style={{
                            backgroundImage: `url(${cameraImg})`,
                            backgroundSize: "37px 37px",
                            backgroundRepeat: "no-repeat",
                            objectFit: "cover",
                            backgroundPosition: "center",
                        }}
                        onClick={captureImg}
                        id="btn-vin-start"
                    ></div>
                    <div className="back-btn">
                        <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
                    </div>
                    {instructions && (
                        <div className="camerInst">
                            <p>{instructions}</p>
                        </div>
                    )}
                    <div
                        id="vin-image"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? { backgroundColor: "black", objectFit: "contain" }
                                : {}
                        }
                        ref={imgRef}
                    >
                        {/* <img
              ref={divImgRef}
              style={
                Object.keys(config).includes("aspectRatio")
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            /> */}
                        <img
                            ref={divImgRef}
                            style={
                                getAspectRatioClientList(clientId, config)
                                    ? { objectFit: "contain" }
                                    : { width: "100vw", height: "100vh" }
                            }
                        />
                        <i
                            className="fas fa-times fa-2x vin-btn-retake"
                            onClick={imageRetake}
                        ></i>
                        <i
                            className="fas fa-check fa-2x vin-btn-next"
                            onClick={imageNext}
                        ></i>
                    </div>
                </div>
            )
            }
        </Fragment >
    );
};

export default New360ImgFeedback;
